import * as _ from 'lodash';
import * as jwtDecode from 'jwt-decode';
import * as moment from 'moment';
interface IUser {
  fullname: string;
  email: string;
  contact: string;
  purpose: string;
  category: string;
  usertype: string;
  first_login: boolean;
  password_reset: boolean;
  subscription: string[]
  organization: {
    name: string;
    org_type: string;
  }
}
export class AccountService implements IUser{
  public static $inject: Array<string> = ["$http", "$q", "$location", "$window", "$timeout"];
  public _id: string;
  public fullname: string;
  public email: string;
  public contact: string;
  public purpose: string;
  public category: string;
  public usertype: string;
  public first_login: boolean;
  public password_reset: boolean;
  public is_ministry: boolean;
  public organization: {name: string, org_type: string};
  public ministry: {_id: string, name: string, display_name: string, code:string, description: string, state: string, datatypes: any, agencies: any};
  public agency: {_id: string, name: string, display_name: string, code:string, description: string, state: string, datatypes: any};
  public $promise: ng.IPromise<any>;
  public isLogin: boolean;
  public isAdmin: boolean;
  public subscription: string[];
  public token: string;
  private df: ng.IDeferred<any>;
  constructor(public $http: ng.IHttpService, private $q: ng.IQService, private $location: ng.ILocationService, private $window: ng.IWindowService, private $timeout: ng.ITimeoutService) {
    this.df = $q.defer();
    this.$promise = this.df.promise;
    this.isLogin = false;
  }
  public login(email: string, password: string, rememberMe: boolean, redirect: string): ng.IPromise<any> {
    let df = this.$q.defer();
    this.$http.post(`${BASE}/login`, {email: email, password: password})
      .then((d:any) => {
        let token = d.data.token;
        let sso = d.data.sso_required;
        this.$http.defaults.headers.common = {'x-access-token':token};
        this.token = token;
        if (rememberMe)
          localStorage.setItem("token", token);
        this.isLogin = true;
        this.me().then(() => {
          if (sso)
            this.$location.path("/migration");
          else if (redirect) {
            this.$location.path(decodeURI(redirect));
          }
          else if (_.includes(['admin', 'internal'], this.usertype))
            this.$location.path("/dashboard");
          else
            this.$location.path('/search');
        });
        df.resolve();
      })
      .catch(err => {
        localStorage.removeItem("token");
        df.reject(err.data);
      });
    return df.promise;
  }

  public register(payload: Object): ng.IPromise<any> {
    return this.$http.post(`${BASE}/register`, payload);
  }

  public me(): ng.IPromise<any> {
    this.refreshToken();
    return this.$http.get(`${BASE}/api/me`).then((d:any) => {
      let user = d.data;
      // if(user.first_login || user.password_reset) {
      //   this.$location.path("/password-reset");
      // }
      _.assign(this, user);
      this.isAdmin = user.usertype === 'admin';
      this.isLogin = true;
      const token = localStorage.getItem("token")
      if (token) {
        this.token = token
      }
      this.df.resolve(user);
    })
    .catch(() => {
      this.isLogin = false;
    })
  }

  public close():void {
    this.df.reject()
  }

  public getAdmin():Promise<any> {
    let df = this.$q.defer();
    this.$promise.then(() => {
      if (this.isAdmin)
        df.resolve();
      else
        df.reject();
    })
    return df.promise;
  }

  public updateMe(payload: IUser): ng.IPromise<any> {
    return this.$http.put(`${BASE}/api/me`, payload).then((d:any) => {
      let _user = d.data;
      _.assign(this, _user);
      this.isAdmin = _user.usertype === 'admin';
    })
  }

  public resetPassword(payload: Object): ng.IPromise<any> {
    return this.$http.post(`${BASE}/api/reset_password`, payload);
  }

  public forgetPassword(email:string): ng.IPromise<any> {
    return this.$http.post(`${BASE}/api/forget_password`, {email: email});
  }

  public migration(user: {}): ng.IPromise<any> {
    return this.$http.post(`${BASE}/api/me/migrate`, user);
  }

  public logout(redirect?: string): void {
    localStorage.removeItem("token");
    this.fullname = "";
    this.email = "";
    this.contact = "";
    this.purpose = "";
    this.category = "";
    this.usertype = ""
    this.isAdmin = false;
    this.isLogin = false;
    this.organization = {name: "", org_type: ""};
    this.df = this.$q.defer();
    this.$promise = this.df.promise;
    const lastVisited = localStorage.getItem('lastVisited');
    localStorage.removeItem("lastVisited");
    this.token = ""
    if (lastVisited) {
      this.$window.open(`${BASE}/#/login?redirect=${lastVisited}`,"_top");
    }
    else {
      this.$window.open(`${BASE}/#/login`,"_top");
    }
  }

  public refreshToken(): void {
    const decoded: tokenPayload  = jwtDecode(this.$http.defaults.headers.common['x-access-token']);
    const diff = moment(decoded.exp * 1000).diff(moment())
    if (diff < 15000 && diff > 0) {
      this.$http.put(`${BASE}/token`, {}).then((d:any) => {
        if (d.data.token) {
          this.$http.defaults.headers.common = {'x-access-token':d.data.token};
          this.token = d.data.token;
          if (localStorage.token) {
            localStorage.setItem('token', d.data.token)
          }
        }
      })
    }
    else if (diff >= 15000) {
      this.$timeout(() => {
        this.refreshToken()
      }, diff - 15000)
    }
    else {
      this.logout()
    }
  }
}

interface tokenPayload {
  exp: number,
  iat: string
}
